import { IUserInfo } from "@/domain/entities/user";
import { UserInfo } from "@/domain/entities/user/userInfo";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";
import {
  HttpRankCode,
  HttpUserInfo,
  IUserInfoParser,
} from "../userRepository.types";
import { RankCode } from "@/types";
import dayjs from "dayjs";

function parseRankCode(rankCode: HttpRankCode) {
  switch (rankCode) {
    case HttpRankCode.REG:
      return RankCode.REG;

    case HttpRankCode.BP:
      return RankCode.BP;

    default:
      return RankCode.NONE;
  }
}

@injectable()
export class UserInfoParser implements IUserInfoParser {
  constructor() {}

  toDomain(data: HttpUserInfo): Result<IUserInfo, ParseError> {
    try {
      const userInfoData: IUserInfo = {
        uid: data.uid,
        memberName: data.memberName,
        clientUid: data.clientUid ?? "",
        clientName: data.clientName ?? "",
        loginId: data.authKey,
        email: data.email ?? "",
        employeeNo: data.employeeNo,
        alias: data.alias,
        phone: data.phone,
        deptName: data.deptName ?? "",
        bpName: data.bpName ?? "",
        dutyNote: data.dutyNote ?? "",
        address: data.addressDetail,
        majorNoticeYn: data.majorNoticeYn, // 중요 알림 설정 수신여부
        rankCode: parseRankCode(data.useRankCode),
        workTimeCode: data.workTimeCode,
        workTimeName: data.workTimeName,
        passwordReuseCount: data.passwordReuseCount,
        bookBlockEndDtm: data.bookBlockEndDtm
          ? dayjs(data.bookBlockEndDtm).format("YYYY-MM-DD HH:mm:ss")
          : undefined,

        boardBlockEndDtm: data.boardBlockEndDtm
          ? dayjs(data.boardBlockEndDtm).format("YYYY-MM-DD HH:mm:ss")
          : undefined,
        isShuttleBoardBlocked: !!data.shuttleBlockYn,
      };
      const userInfo = new UserInfo(userInfoData);
      return ok(userInfo);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }

  fromDomain(changedUserInfo: Record<string, any>): Record<string, any> {
    return {
      ...changedUserInfo,
      clientUid:
        changedUserInfo.clientUid === "" ? null : changedUserInfo.clientUid,
      bpName: changedUserInfo.bpName === "" ? null : changedUserInfo.bpName,
    };
  }
}
